import { css, SerializedStyles } from "@emotion/react/macro";
import { Color } from "../enums";

/**
 * ルビ（振り仮名）のスタイル
 *
 * @example
 * const Content = styled.div`
 *   ${rubyStyles}
 * `;
 */
export const rubyStyles: SerializedStyles = css`
  ruby {
    ruby-align: space-around;

    rt {
      font-size: 0.5em;
      color: ${Color.ACCENT_700};
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;
